import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { MatDialog, MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { DesignService } from "src/app/design/design.service";
import { DesignsModel, SystemDesign } from "src/app/design/design.model";
import { System, singleSystem } from "src/app/system/system";
import { EquipmentService } from "src/app/equipment/equipment.service";
import { Equipment, EquipmentsEntity } from "src/app/equipment/equipment";
import { ViewSystemEquipmentComponent } from "../view-system-equipment/view-system-equipment.component";
import { SystemService } from "../system.service";
import { AuthService } from "src/app/auth.service";
import { NgForm } from "@angular/forms";
import { GlobalConstants } from "src/app/shared/constants/constants";

@Component({
  selector: "app-new-system-design",
  templateUrl: "./new-system-design.component.html",
  styleUrls: ["./new-system-design.component.css"],
})
export class NewSystemDesignComponent implements OnDestroy, AfterViewInit {
  @ViewChild("systemForm") systemForm: NgForm;

  private subscription$ = new Subscription();
  showLoader: boolean = true;
  showInputLoader: boolean = false
  selectedEquipment: any;
  currentEquipment: string;
  fanSpeedMode: string[] = GlobalConstants.fanSpeedMode;
  hvac_desing_id: string | number;
  furnaceInput:boolean = false;

  systemEditMode: boolean = false;
  system: singleSystem;
  verifySystemName: boolean;
  editMode: boolean = false;
  color = GlobalConstants.ProgressBar.color;
  mode = GlobalConstants.ProgressBar.mode;
  bufferValue = GlobalConstants.ProgressBar.bufferValue;
  progresBarValue: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private designService: DesignService,
    private equipmentService: EquipmentService,
    private systemService: SystemService,
    private snackBar: MatSnackBar,
    public auth: AuthService
  ) {
    this.system = new singleSystem();

    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams?.id) {
        queryParams.editMode === "true"
          ? (this.getSystemDetails(queryParams.id),
            this.getDesignDetail(queryParams.id),
            (this.editMode = true))
          : (this.getDesignDetail(queryParams.id), (this.editMode = false));
      }
    });
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.validateInputs();
    }, 500);
  }

  design: DesignsModel;
  equipments: EquipmentsEntity[];
  filterEquipments: EquipmentsEntity[];
  equipment: EquipmentsEntity;

  ngOnInit() {

    console.log(this.systemForm);
    this.auth.userProfileSubject$.subscribe(
      (profile) => {
        if (profile) {
          this.getEquipmentList();
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackBar.open(
          `Error in Getting Designer and Contractor Details`,
          "",
          {
            duration: 2000,
          }
        );
      }



    );

    if(this.selectedEquipment?.furnacemn){
      this.furnaceInput = true;
    }

    this.system.maxheatgain = 0;
    this.system.gfh = 0;
  }

  /**
   * Get  System By Id
   */
  getSystemDetails(systemId) {
    this.showLoader = true;
    this.subscription$.add(
      this.systemService.getSingleSystem(systemId).subscribe(
        (result: System) => {
          this.system = result.system[0];
          if (this.system.design_id) {
            this.hvac_desing_id = this.system.design_id;
          }
          this.equipmentService
            .getSingleEquipment(this.system.equipment_id)
            .subscribe((result: Equipment) => {
              if (result?.Equipment?.length) {
                this.onEquipmentSelection(result.Equipment[0]);
                this.sensibleHeatGain();
              }
            });
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Design List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Get  Designs By Id
   */
  getDesignDetail(SystemDesign_id) {
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getViewDesigns(SystemDesign_id).subscribe(
        (result: SystemDesign) => {
          this.design = result.Designs;
          if (this.design?.hvac_design_id) {
            this.hvac_desing_id = this.design?.hvac_design_id;
          }
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Design List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Get Equipments List
   */
  getEquipmentList() {
    this.showLoader = true;
    this.subscription$.add(
      this.equipmentService.getEquipmentList().subscribe(
        (result: Equipment) => {
          this.equipments = result.equipments;
          this.filterEquipments = result.equipments;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Equipment List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * verify system name
   */
  verifySystem() {
    if (this.system.name) {
      this.showInputLoader = true;
      this.subscription$.add(
        this.systemService.verifySystem(this.system.name).subscribe(
          (result: System) => {
            this.verifySystemName = result.system == 1 ? true : false;
            this.showInputLoader = false;
          },
          (error) => {
            this.showInputLoader = false;
          }
        )
      );
    }

  }

  inputFieldValidation(event) { }
  /**
   * Get Equipment Details By Id
   */
  onEquipmentSelection(selectedEquipment: any) {
    console.log('Called it.');
    if (selectedEquipment?.equipment_id) {
      this.system.equipment_id = selectedEquipment.equipment_id;
      this.currentEquipment =
        selectedEquipment?.equipmentname +
        "-" +
        selectedEquipment?.equipmentdescription;
      this.showLoader = true;
      this.subscription$.add(
        this.equipmentService
          .getSingleEquipment(this.system.equipment_id)
          .subscribe(
            (result: any) => {
              if (result?.Equipment?.length) {
                console.log(this.systemForm);

                this.equipment = result.Equipment[0];
                this.selectedEquipment = result.Equipment[0];
                this.checkCoolingSizeLimit();

                if(this.selectedEquipment.furnacemn?.length > 0){
                  this.furnaceInput = true;
                  console.log(this.systemForm);
                }
              }
              this.showLoader = false;
            },
            (error) => {
              this.showLoader = false;
              this.snackBar.open(`Error in Getting Equipment Details. `, "", {
                duration: 2000,
              });
            }
          )
      );
    }
  }

  /**
   * calculate sensible Heat Gain
   */

  sensibleHeatGain() {
    this.system.maxheatgain = Math.max(
      this.system.dessheatgainn,
      this.system.dessheatgainne,
      this.system.dessheatgaine,
      this.system.dessheatgainse,
      this.system.dessheatgains,
      this.system.dessheatgainsw,
      this.system.dessheatgainw,
      this.system.dessheatgainnw
    );
    this.system.destotlheatgainn = this.system?.deslheatgain
      ? Number(this.system.dessheatgainn) + Number(this.system?.deslheatgain)
      : Number(this.system.dessheatgainn);
    this.system.destotlheatgainne = this.system?.deslheatgain
      ? Number(this.system.dessheatgainne) + Number(this.system?.deslheatgain)
      : Number(this.system.dessheatgainne);
    this.system.destotlheatgaine = this.system?.deslheatgain
      ? Number(this.system.dessheatgaine) + Number(this.system?.deslheatgain)
      : Number(this.system.dessheatgaine);
    this.system.destotlheatgainse = this.system?.deslheatgain
      ? Number(this.system.dessheatgainse) + Number(this.system?.deslheatgain)
      : Number(this.system.dessheatgainse);
    this.system.destotlheatgains = this.system?.deslheatgain
      ? Number(this.system.dessheatgains) + Number(this.system?.deslheatgain)
      : Number(this.system.dessheatgains);
    this.system.destotlheatgainsw = this.system?.deslheatgain
      ? Number(this.system.dessheatgainsw) + Number(this.system?.deslheatgain)
      : Number(this.system.dessheatgainsw);
    this.system.destotlheatgainw = this.system?.deslheatgain
      ? Number(this.system.dessheatgainw) + Number(this.system?.deslheatgain)
      : Number(this.system.dessheatgainw);
    this.system.destotlheatgainnw = this.system?.deslheatgain
      ? Number(this.system.dessheatgainnw) + Number(this.system?.deslheatgain)
      : Number(this.system.dessheatgainnw);

    this.system.maxtotal = Math.max(
      this.system.destotlheatgainn,
      this.system.destotlheatgainne,
      this.system.destotlheatgaine,
      this.system.destotlheatgainse,
      this.system.destotlheatgains,
      this.system.destotlheatgainsw,
      this.system.destotlheatgainw,
      this.system.destotlheatgainnw
    );
    this.system.hrt = Math.min(
      this.system.destotlheatgainn,
      this.system.destotlheatgainne,
      this.system.destotlheatgaine,
      this.system.destotlheatgainse,
      this.system.destotlheatgains,
      this.system.destotlheatgainsw,
      this.system.destotlheatgainw,
      this.system.destotlheatgainnw
    );

    this.system.gfh = this.system.maxtotal - this.system.hrt;
    this.checkCoolingSizeLimit();

  }

  /**
   * check cooling size limit
   */

  onSelectCompressorSpeed(speed: String){

    console.log(speed);
    console.log(speed.split(':')[0].toLowerCase());
    console.log(this.equipment.compressortype.toLowerCase());
    if(speed.split(':')[0].toLowerCase() != this.equipment.compressortype.toLowerCase()){
      console.log('Not Equal!')


        const dialogRef = this.dialog.open( WarningDialogComponent, {
          height: '260px',
          width: '300px',
          data: {
            userSelected : speed.split(':')[0].toLowerCase(),
            equip : this.equipment.compressortype.toLowerCase()
          }
        });


    }

  }



  checkCoolingSizeLimit() {
    this.system.coolsizingpct =
      (Number(this.equipment?.totaldescap) / Number(this.system?.maxtotal)) * 100;
    if (
      this.system.coolingsizinglimit ==
      GlobalConstants.CoolingSizingLimit.Single_Speed
    ) {
      if (this.system.coolsizingpct >= 90 && this.system.coolsizingpct <= 130) {
        this.system.coolsizepctlimit3 = GlobalConstants.CoolingSizingLimit.Designer_Verified;
        this.system.coolsizepctlimit2 = "";
      } else {
        this.system.coolsizepctlimit2 = GlobalConstants.CoolingSizingLimit.Check_please;
        this.system.coolsizepctlimit3 = "";
      }
    } else if (
      this.system.coolingsizinglimit ==
      GlobalConstants.CoolingSizingLimit.Two_Speed
    ) {
      if (this.system.coolsizingpct >= 90 && this.system.coolsizingpct <= 140) {
        this.system.coolsizepctlimit3 = GlobalConstants.CoolingSizingLimit.Designer_Verified;
        this.system.coolsizepctlimit2 = "";
      } else {
        this.system.coolsizepctlimit2 = GlobalConstants.CoolingSizingLimit.Check_please;
        this.system.coolsizepctlimit3 = "";
      }
    } else {
      if (
        this.system.coolingsizinglimit ==
        GlobalConstants.CoolingSizingLimit.Variable_Speed
      ) {
        if (
          this.system.coolsizingpct >= 90 &&
          this.system.coolsizingpct <= 160
        ) {
          this.system.coolsizepctlimit3 = GlobalConstants.CoolingSizingLimit.Designer_Verified;
          this.system.coolsizepctlimit2 = "";
        } else {
          this.system.coolsizepctlimit2 = GlobalConstants.CoolingSizingLimit.Check_please;
          this.system.coolsizepctlimit3 = "";
        }
      } else {
        this.system.coolsizepctlimit2 = "";
        this.system.coolsizepctlimit3 = "";
      }
    }

    this.system.heatsizepctlimits =
      (Number(this.equipment?.furnoutput) /
        Number(this.system?.desttotlheatloss)) *
      100;
    if (this.system.heatsizinglimit == GlobalConstants.HeatSizingLimit.Used_for_heating_Only) {
      if (
        Number(this.system.heatsizepctlimits) >= 100 &&
        Number(this.system.heatsizepctlimits) <= 140
      ) {
        this.system.heatsizepctlimits3 = GlobalConstants.HeatSizingLimit.Designer_Verified;
        this.system.heatsizepctlimits2 = "";
      } else {
        this.system.heatsizepctlimits2 = GlobalConstants.HeatSizingLimit.Check_please;
        this.system.heatsizepctlimits3 = "";
      }
    } else {
      if (
        this.system.heatsizinglimit ==
        GlobalConstants.HeatSizingLimit.Paired_With_Cooling
      ) {
        if (
          Number(this.system.heatsizepctlimits) >= 100 &&
          Number(this.system.heatsizepctlimits) <= 400
        ) {
          this.system.heatsizepctlimits3 = GlobalConstants.HeatSizingLimit.Designer_Verified;
          this.system.heatsizepctlimits2 = "";
        } else {
          this.system.heatsizepctlimits2 = GlobalConstants.HeatSizingLimit.Check_please;
          this.system.heatsizepctlimits3 = "";
        }
      } else {
        this.system.heatsizepctlimits2 = "";
        this.system.heatsizepctlimits3 = "";
      }
    }
  }

  /**
   * View System Equipment dialog
   */
  viewSystemEquipment() {
    const dialogRef = this.dialog.open(ViewSystemEquipmentComponent, {
      width: "75%",
      height: "100%",
      data: {
        equipment: this.equipment,
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => { });
  }

  returnFixed(digit: number) {
    console.log(digit);
    return Number(digit).toFixed(1);
  }

  /**
   * Saving Equipment
   */
  save() {
    if (this.systemForm.valid) {


      this.system.hvac_design_id = this.hvac_desing_id;
      this.system.systemcomplete = true;
      this.system.completesystems = true;
      let operation = this.editMode ? "updateSystem" : "newSystem";
      this.showLoader = true;

      this.subscription$.add(
        this.systemService.registerDesign(this.system).subscribe(
          (data: any) => {
            this.systemService[operation](this.system).subscribe(
              (system: any) => {
                this.showLoader = false;
                this.router.navigate(["/newSystem_dsg_room"], {
                  queryParams: {
                    design_id: this.system.hvac_design_id,
                    system_id: system.Id,
                  },
                });
                this.snackBar.open(
                  `${this.editMode
                    ? "System Updated Sucessfully"
                    : "System Created Sucessfully"
                  } `,
                  "",
                  {
                    duration: 2000,
                  }
                );
              }
            );
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(
              `${this.editMode
                ? "Error in Updating System"
                : "Error in Creating System"
              }`,
              "",
              {
                duration: 2000,
              }
            );
          }
        )
      );
    }
  }

  /**
   *
   * @param equipment search equipment
   */
  searchEquipment(equipment: any) {
    let data = equipment.target.value.toLocaleLowerCase();
    this.equipments = this.filterEquipments.filter((searchData: EquipmentsEntity) => {
      return (searchData?.equipmentdescription?.toLocaleLowerCase().match(data) || (searchData?.equipmentname?.toLocaleLowerCase().match(data) ))
    });

  }

  /**
   * display the selected equipment in autoComplete dropdown
   * @param subject
   * @returns
   */
  displaySelectedEquipment(selectedEquipment: EquipmentsEntity) {
    if(selectedEquipment){
      return selectedEquipment?.equipmentname?.trim() + "-" + selectedEquipment?.equipmentdescription;
    }
  }

  /**
   * validate input fields and show progress bar
   */

  validateInputs() {
    let inputCount = 0;
    Object.keys(this.systemForm.controls).map((field) => {
      if (this.systemForm.controls[field].value) inputCount++;
    });

    this.progresBarValue =
      (inputCount / Object.keys(this.systemForm.controls).length) * 100;
  }
  /**
   * unsubscribe the subscriptions
   */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}

@Component({
  template: `
    <h1 mat-dialog-title>Warning!</h1>
    <div style="min-height:130px">
      You've selected {{data.userSelected}} here, but the equipment you've assigned states this system is a {{data.equip}}
    </div>
    <button mat-button (click)="dref.close()"  style="margin-left: 40px;background: #ffffffaf;">Close</button>


  `
})
export class WarningDialogComponent {

  constructor(public dref: MatDialogRef<WarningDialogComponent>,  @Inject(MAT_DIALOG_DATA) public data:any){}

}
